import { useQuery } from '@apollo/client/react';
import { orgmgrGql, ResultOf } from '@nemlia/hasura-gql';
const STYRA_GET_ORGANISATION_LIST = orgmgrGql(/* GraphQL */`
  query STYRA_GET_ORGANISATION_LIST {
    ta_organisation(where: { archived: { _eq: false } }, order_by: { name: asc }) {
      id
      name
      supplier_id
      config
      status
      ta_supplier {
        name
      }
      tz: organisation_timezone
    }
  }
`);
export type OrganisationList = ResultOf<typeof STYRA_GET_ORGANISATION_LIST>['ta_organisation'];
export const useGetOrganisationList = () => {
  return useQuery(STYRA_GET_ORGANISATION_LIST);
};